export const SEARCH_TYPE = {
    AUTOCOMPLETE: 1,
    NUMERIC: 2,
    INPUT: 3,
    DATEPICKER: 4
}